// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2ZC_j","row":"ProcedureTreatmentSummary_row__1seKv"};